import { Action } from 'common/interfaces/root';
import { overviewActionTypes as T } from '../actions';

const initState: OverviewV2.ProductsStatsStore = {
  loading: true,
  error: null,
  entries: null,
};

export default (
  state: OverviewV2.ProductsStatsStore = initState,
  { type, payload }: Action
): OverviewV2.ProductsStatsStore => {
  switch (type) {
    case T.GET_PRODUCTS_STATS:
      return { ...state, loading: true };

    case T.GET_PRODUCTS_STATS_SUCCESS:
      return { ...state, loading: false, entries: payload };

    case T.GET_PRODUCTS_STATS_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
